import React, { useEffect, useState } from 'react'
import TimeRangePicker from './TimeRangePicker';
import axiosInstance from '../../Redux/AxiosInstance';
import { toast, ToastContainer } from 'react-toastify';

function TimeRange() {
    const [timeRange, setTimeRange] = useState({
    fromHour: "09",
    fromMinute: "00",
    fromAMPM: "AM",
    toHour: "05",
    toMinute: "00",
    toAMPM: "PM",
  });
const [loading, setLoading] = useState(false);
const [apiData, setApiData] = useState(null);
  const convertToApiFormat = (timeRange) => {
  const start_time = `${timeRange.fromHour}:${timeRange.fromMinute} ${timeRange.fromAMPM}`;
  const end_time = `${timeRange.toHour}:${timeRange.toMinute} ${timeRange.toAMPM}`;

  return { start_time, end_time };
};

const parseTime = (timeString) => {
  // Example: "09:00 AM"
  if (!timeString) return null;

  const [time, ampm] = timeString.split(" ");  // ["09:00", "AM"]
  const [hour, minute] = time.split(":");      // ["09", "00"]

  return { hour, minute, ampm };
};

const getAllVisitors = async () => {
    try {
        const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}list_times`)
        console.log(response)
        if(response.status === 200){
            setApiData(response.data.data[0]);
            // setPaginationData(response.data.pagination_details);
        }
        
    } catch (error) {
        console.log(error.response.status, 'list devices')
        if(error?.response?.status === 404){
            // setVisitorsList([]);
        }
       
    }
}


  useEffect(() => {
    getAllVisitors();
  }, []);

  useEffect(() => {
  if (apiData) {
    const start = parseTime(apiData.start_time);
    const end = parseTime(apiData.end_time);

    if (start && end) {
      setTimeRange({
        fromHour: start.hour,
        fromMinute: start.minute,
        fromAMPM: start.ampm,
        toHour: end.hour,
        toMinute: end.minute,
        toAMPM: end.ampm,
      });
    }
  }
}, [apiData]);

  const saveDevice = async () => {
               try {
                const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}create_time`, {
                    ...convertToApiFormat(timeRange)
                })
                console.log(response)
                if(response?.data?.status === 200){
                    console.log('created')
                    toast.success("Time Setted Successfully")
                    getAllVisitors()
                    // setTimeout(() => {
                    //     navigate('/create_organization')
                    // }, 1000)
                    
                    // setPersonalDetailsData({...initialDeviceData})
                }
                setLoading(false)
            } catch (error) {
                console.log(error.response, 'saveDevice')
                toast.error(error?.response?.data?.detail || "Something went wrong")
                setLoading(false)
            }
        }

  return (
    <div>
        <ToastContainer />
      <TimeRangePicker value={timeRange} onChange={setTimeRange} saveDevice={saveDevice}/>
    </div>
  )
}

export default TimeRange